import React from 'react';
import ContentLoader from "react-content-loader";

export default function PagePlaceholder() {
  return (
    <div className="col-12">
      <ContentLoader viewBox="0 0 500 450" className="mb-3">
        <rect x="0" y="0" rx="0" ry="0" width="80%" height="15" />
        <rect x="0" y="20" rx="0" ry="0" width="100%" height="20" />
        <rect x="0" y="45" rx="0" ry="0" width="50" height="10" />
        <rect x="55" y="45" rx="0" ry="0" width="30" height="10" />
        <rect x="0" y="60" rx="0" ry="0" width="100%" height="250" />
        <rect x="0" y="315" rx="0" ry="0" width="100%" height="10" />
        <rect x="0" y="330" rx="0" ry="0" width="100%" height="10" />
        <rect x="0" y="345" rx="0" ry="0" width="100%" height="10" />
        <rect x="0" y="360" rx="0" ry="0" width="100%" height="10" />
        <rect x="0" y="375" rx="0" ry="0" width="100%" height="10" />
        <rect x="0" y="390" rx="0" ry="0" width="100%" height="10" />
        <rect x="0" y="405" rx="0" ry="0" width="100%" height="10" />
        <rect x="0" y="420" rx="0" ry="0" width="70%" height="10" />
      </ContentLoader>
    </div>
  )
}
